import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";

import { useRootStore } from "store";
import { Input } from "components/input/Input";
import { PrimaryButton } from "components/button/Button";
import Link from "components/link/Link";
import OverlayLoader from "components/loader/OverlayLoader";

import "./SetPassword.scss";

export default function SetPassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { tokenIsSet, isValid, validateToken, sendSetNewPassword } = useRootStore(
    (state) => state.resetPassword
  );

  const { isNewPass } = useRootStore((state) => state.notifications);

  const { key } = useParams();

  const [clicked, setClicked] = useState(false);
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (key) {
      validateToken(key);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (tokenIsSet) {
      setIsLoading(false);
      navigate("/dashboard");
    }
  }, [tokenIsSet, dispatch, navigate]);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (key) {
      sendSetNewPassword(password1, key);
      setClicked(true);
      setIsLoading(false);
      isNewPass(true);
    }
  };

  const passwordFeedback = () => {
    if (password1.length === 0) {
      return "";
    }

    const gotNumbers = password1.match(/\d/g) || [];
    const gotBigLetters = password1.match(/[A-ZÅÄÖ]/g) || [];
    const gotSmallLetters = password1.match(/[a-zåäö]/g) || [];

    return password1.length < 8
      ? "Lösenordet måste minst vara åtta tecken långt"
      : gotNumbers.length < 2
        ? "Lösenordet måste minst innehålla två siffror"
        : gotBigLetters.length < 1
          ? "Lösenordet måste minst innehålla en stor bokstav"
          : gotSmallLetters.length < 2
            ? "Lösenordet måste minst innehålla två små bokstäver"
            : password1 !== password2
              ? "Lösenord matchar ej"
              : "";
  };

  const isFormValid = () => {
    return password1.length !== 0 && !passwordFeedback();
  };

  return (
    <>
      {!isValid ? (
        <div className="box">
          <h1>Länken inte längre giltig</h1>
          <p>
            Giltighetstiden för länken har gått ut. Vänligen{" "}
            <Link to="/resetpassword">begär en ny länk</Link>, om du vill ändra
            ditt lösenord.
          </p>
        </div>
      ) : (
        <OverlayLoader isLoading={isLoading}>
          <>
            <div className="box">
              <h1>Ange nytt lösenord</h1>
              <p>
                Vänligen ange ett nytt lösenord nedan. Lösenordet måste vara
                minst 8 tecken långt, innehålla en stor bokstav, två små
                bokstäver och minst två numeriska tecken.
              </p>
              <form onSubmit={(e) => handleSubmit(e)}>
                <Input
                  type="password"
                  placeholder="Ange nytt lösenord"
                  onChange={(e) => setPassword1(e.target.value)}
                />
                <br />
                <Input
                  type="password"
                  placeholder="Upprepa ditt nya lösenord"
                  onChange={(e) => setPassword2(e.target.value)}
                />
                <br />
                <div className="errorMessage">{passwordFeedback()}</div>
                <PrimaryButton
                  disabled={!isFormValid() || clicked}
                  type="submit"
                >
                  Sätt lösenord
                </PrimaryButton>
              </form>
            </div>
          </>
        </OverlayLoader>
      )}
    </>
  );
}
